<div class="menu-header-container">
  <ad-icon
    class="menu-header-icon"
    [glyph]="glyph"
    color="neutral-900"
    (click)="onIconClick()"
  ></ad-icon>
  <span class="text-p1--semibold menu-header-title">{{ title }}</span>
</div>
